"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameSummary = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

var _helpers = require("../../util/helpers");

require("./GameSummary.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Slobodan Djordjevic
 */
var GameSummary = function GameSummary(props) {
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "game-summary-row"
  }, props.showTime && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "date"
  }, "PLAYED ", (0, _helpers.getDiffDates)(props.diffDates)), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "home"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "circle",
    style: (0, _helpers.getHomeTeamStyle)(props.homeTeamStyle)
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "team-name"
  }, props.homeTeamName), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "score"
  }, props.homeTeamScore ? props.homeTeamScore : 0)), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "away"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "circle",
    style: (0, _helpers.getAwayTeamStyle)(props.awayTeamStyle)
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "team-name"
  }, props.awayTeamName), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "score"
  }, props.awayTeamScore ? props.awayTeamScore : 0)));
};

exports.GameSummary = GameSummary;